var nurseslounge_degrees = {
    home:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_degrees.submenu($params, function(){
            $(".nav-underline a:eq(0)").click();
        });
    },
    home_sub:function($params){
        nurseslounge_degrees_home.init($params);
    },
    submenu:function($params, cback){
        $(".nav-underline a").unbind().click(function(){
            $(".nav-underline a").removeClass('active');
            nurseslounge_degrees.submenu_open(this, $(this).data('url'),  'home_sub', $params)
        });
        nurseslounge_degrees.menu_selector();
        cback();
    },
    submenu_open:function($this, $url, $module, $params){
        $($this).addClass('active');
        router.pause();
        router.navigate($url);
        router.resume();
        $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
        libs.subrender($url, 'nurseslounge_degrees', $module, $params, 'POST');
    },
    menu_selector:function(){
        libs.globalUrl();
    }
};
